import React from 'react'
import Resume from './Resume';
import {Link} from "react-router-dom";
import Education from './Education';
function First() {
  return (

<div className="container">
    <div className="first-header">


    <div className="first-headerItem1">

       <h1>Harshit Agrawal</h1>
       <Link to="/">
        <img alt="Avatar-image" className="first-headerImg" src="https://i.pinimg.com/originals/ed/09/16/ed0916a8c0d1d29b4fb90d02af33bc09.png"/>
        </Link>
    </div>
<div className="first-header2">

       <div className="first-headerItem">

              <Link className="link" to='/Resume'>
                <h1>My profile</h1>
              </Link>
         </div>
         <div className="first-headerItem">
           <Link className="link" to='/Education'>

         <h1>Education</h1>
         </Link>
       </div>
         <div className="first-headerItem">
          <Link className="link" to='/Interest'>
          <h1>Interests</h1>
          </Link>
           </div>
           <div className="first-headerItem">
             <Link className="link" to='/About'>
            <h1>About me</h1>
               </Link>
             </div>
             <div className="first-headerItem">
                 <h1>Blog</h1>
             </div>
     </div>


    </div>
    </div>


  )
}

export default First
